module.exports = __webpack_public_path__ + "assets/media/store-about.6350b7e5.svg";